import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import pruef_PlanConstants from "../Constants/Pruef_PlanConstants";

let pruefgroupList = null;
let addorUpdatePruefGroup = null;
let deletePruefGroup = null;
let currentpruefPlan = null;
let activePruefPlan = null;
let kostPruefGroups = null;
let addorUpdateEquipmentGroupResult = null;
let pruefPlanQuestion = null;
let addorUpdateQuestionResult = null;
let copyPruefPlanResult = null;
let deletePruefPlan = null;
let activeEquipmentPruefPlan = null;
let addorUpdateEquipmentPruefPlanResult = null;
let deleteEquipmentPruefPlan = null;
let pruefplanPublishResult = null;
let activatePruefplanResult = null;
let deactivatePruefplanResult = null;
let checkListResult = null;
let checkListDetailsResult = null;
let publishChecklistResult = null;
let checkListForEqGrpResult = null;
let deactivateChecklistResult = null;
let deleteChecklistResult = null;
let saveChecklistAsTemplateResult = null;
let checklistTemplateRes = null;
let deleteChecklistTemplateRes = null;
class PruefPlanStores extends EventEmitter {
  getPruefGroupList() {
    return pruefgroupList;
  }
  setPruefGroupList(res) {
    pruefgroupList = res;
  }
  getAddorUpdatePruefGroupResult() {
    return addorUpdatePruefGroup;
  }

  setAddorUpdatePruefGroupResult(res) {
    addorUpdatePruefGroup = res;
  }
  getDeletePruefGroup() {
    return deletePruefGroup;
  }

  setDeletePruefGroup(res) {
    deletePruefGroup = res;
  }

  getCurrentPruefPlan() {
    return currentpruefPlan;
  }
  setCurrentPruefPlan(res) {
    currentpruefPlan = res;
  }
  getActivePruefPlan() {
    return activePruefPlan;
  }
  setActivePruefPlan(res) {
    activePruefPlan = res;
  }
  getKostPruefGroups() {
    return kostPruefGroups;
  }
  setKostPruefGroups(res) {
    kostPruefGroups = res;
  }
  getAddorUpdatePruefPlanResult() {
    return addorUpdateEquipmentGroupResult;
  }

  setAddorUpdatePruefPlanResult(res) {
    addorUpdateEquipmentGroupResult = res;
  }
  getPruefPlanQuestion() {
    return pruefPlanQuestion;
  }
  setPruefPlanQuestion(res) {
    pruefPlanQuestion = res;
  }
  getAddorUpdatePruefPlanQuestionResult() {
    return addorUpdateQuestionResult;
  }

  setAddorUpdatePruefPlanQuestionResult(res) {
    addorUpdateQuestionResult = res;
  }
  getCopyPruefPlanResult() {
    return copyPruefPlanResult;
  }

  setCopyPruefPlanResult(res) {
    copyPruefPlanResult = res;
  }
  getDeletePruefPlan() {
    return deletePruefPlan;
  }

  setDeletePruefPlan(res) {
    deletePruefPlan = res;
  }
  getEquipmentCurrentPruefPlan() {
    return activeEquipmentPruefPlan;
  }
  setEquipmentCurrentPruefPlan(res) {
    activeEquipmentPruefPlan = res;
  }
  getAddorUpdateEquipmentPruefPlanResult() {
    return addorUpdateEquipmentPruefPlanResult;
  }

  setAddorUpdateEquipmentPruefPlannResult(res) {
    addorUpdateEquipmentPruefPlanResult = res;
  }
  getDeleteEquipmentPruefGroup() {
    return deleteEquipmentPruefPlan;
  }

  setDeleteEquipmentPruefGroup(res) {
    deleteEquipmentPruefPlan = res;
  }

  getPublishPruefPlanResult() {
    return pruefplanPublishResult;
  }

  setPublishPruefPlanResult(res) {
    pruefplanPublishResult = res;
  }

  getActivatePruefPlanResult() {
    return activatePruefplanResult;
  }

  setActivatePruefPlanResult(res) {
    activatePruefplanResult = res;
  }

  getDeActivatePruefPlanResult() {
    return deactivatePruefplanResult;
  }

  setDeActivatePruefPlanResult(res) {
    deactivatePruefplanResult = res;
  }

  getCheckListResult() {
    return checkListResult;
  }

  setCheckListResult(res) {
    checkListResult = res;
  }

  getCheckListDetails() {
    return checkListDetailsResult;
  }

  setCheckListDetails(res) {
    checkListDetailsResult = res;
  }

  getPublishCheckListResult() {
    return publishChecklistResult;
  }

  setPublishCheckListResult(res) {
    publishChecklistResult = res;
  }

  getCheckListForEqGrpResult() {
    return checkListForEqGrpResult;
  }

  setCheckListForEqGrpResult(res) {
    checkListForEqGrpResult = res;
  }

  getDeActivateChecklistResult() {
    return deactivateChecklistResult;
  }

  setDeActivateChecklistResult(res) {
    deactivateChecklistResult = res;
  }

  getDeleteChecklistResult() {
    return deleteChecklistResult;
  }

  setDeleteChecklistResult(res) {
    deleteChecklistResult = res;
  }

  getSaveChecklistAsTemplateResult() {
    return saveChecklistAsTemplateResult;
  }

  setSaveChecklistAsTemplateResult(res) {
    saveChecklistAsTemplateResult = res;
  }

  getChecklistTemplateResult() {
    return checklistTemplateRes;
  }

  setChecklistTemplateResult(res) {
    checklistTemplateRes = res;
  }

  getDeleteChecklistTemplateResult() {
    return deleteChecklistTemplateRes;
  }

  setDeleteChecklistTemplateResult(res) {
    deleteChecklistTemplateRes = res;
  }

  emitChange(eventName) {
    this.emit(eventName);
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case pruef_PlanConstants.GET_PruefGroup_SUCCESS:
        this.setPruefGroupList(action.result);
        break;
      case pruef_PlanConstants.GET_PruefGroup_FAILURE:
        this.setPruefGroupList(action.result);
        break;
      case pruef_PlanConstants.ADDORUPDATE_PruefGroup_SUCCESS:
        this.setAddorUpdatePruefGroupResult(action.result);
        break;
      case pruef_PlanConstants.ADDORUPDATE_PruefGroup_FAILURE:
        this.setAddorUpdatePruefGroupResult(action.result);
        break;
      case pruef_PlanConstants.DELETE_PruefGroup_SUCCESS:
        this.setDeletePruefGroup(action.result);
        break;
      case pruef_PlanConstants.DELETE_PruefGroup_FAILURE:
        this.setDeletePruefGroup(action.result);
        break;
      case pruef_PlanConstants.GET_PruefPlan_SUCCESS:
        this.setCurrentPruefPlan(action.result);
        break;
      case pruef_PlanConstants.GET_PruefPlan_FAILURE:
        this.setCurrentPruefPlan(action.result);
        break;
      case pruef_PlanConstants.GET_ActivePruefPlan_SUCCESS:
        this.setActivePruefPlan(action.result);
        break;
      case pruef_PlanConstants.GET_ActivePruefPlan_FAILURE:
        this.setActivePruefPlan(action.result);
        break;
      case pruef_PlanConstants.GET_KostPruefGroups_SUCCESS:
        this.setKostPruefGroups(action.result);
        break;
      case pruef_PlanConstants.GET_KostPruefGroups_FAILURE:
        this.setKostPruefGroups(action.result);
        break;
      case pruef_PlanConstants.ADDORUPDATE_PruefPlan_SUCCESS:
        this.setAddorUpdatePruefPlanResult(action.result);
        break;
      case pruef_PlanConstants.ADDORUPDATE_PruefPlan_FAILURE:
        this.setAddorUpdatePruefPlanResult(action.result);
        break;
      case pruef_PlanConstants.GET_PruefPlanQuestion_SUCCESS:
        this.setPruefPlanQuestion(action.result);
        break;
      case pruef_PlanConstants.GET_PruefPlanQuestion_FAILURE:
        this.setPruefPlanQuestion(action.result);
        break;
      case pruef_PlanConstants.ADDORUPDATE_PruefPlanQuestion_SUCCESS:
        this.setAddorUpdatePruefPlanQuestionResult(action.result);
        break;
      case pruef_PlanConstants.ADDORUPDATE_PruefPlanQuestion_FAILURE:
        this.setAddorUpdatePruefPlanQuestionResult(action.result);
        break;
      case pruef_PlanConstants.COPY_PruefPlan_SUCCESS:
        this.setCopyPruefPlanResult(action.result);
        break;
      case pruef_PlanConstants.COPY_PruefPlan_FAILURE:
        this.setCopyPruefPlanResult(action.result);
        break;
      case pruef_PlanConstants.DELETE_PruefPlan_SUCCESS:
        this.setDeletePruefPlan(action.result);
        break;
      case pruef_PlanConstants.DELETE_PruefPlan_FAILURE:
        this.setDeletePruefPlan(action.result);
        break;
      case pruef_PlanConstants.GET_Equipment_PruefPlan_SUCCESS:
        this.setEquipmentCurrentPruefPlan(action.result);
        break;
      case pruef_PlanConstants.GET_Equipment_PruefPlan_FAILURE:
        this.setEquipmentCurrentPruefPlan(action.result);
        break;
      case pruef_PlanConstants.ADDORUPDATE_Equipment_PruefPlan_SUCCESS:
        this.setAddorUpdateEquipmentPruefPlannResult(action.result);
        break;
      case pruef_PlanConstants.ADDORUPDATE_Equipment_PruefPlan_FAILURE:
        this.setAddorUpdateEquipmentPruefPlannResult(action.result);
        break;
      case pruef_PlanConstants.DELETE_Equipment_PruefPlan_SUCCESS:
        this.setDeleteEquipmentPruefGroup(action.result);
        break;
      case pruef_PlanConstants.DELETE_Equipment_PruefPlan_FAILURE:
        this.setDeleteEquipmentPruefGroup(action.result);
        break;
      case pruef_PlanConstants.PUBLISH_PruefPlan_SUCCESS:
        this.setPublishPruefPlanResult(action.result);
        break;
      case pruef_PlanConstants.PUBLISH_PruefPlan_FAILURE:
        this.setPublishPruefPlanResult(action.result);
        break;
      case pruef_PlanConstants.ACTIVATE_PruefPlan_SUCCESS:
        this.setActivatePruefPlanResult(action.result);
        break;
      case pruef_PlanConstants.ACTIVATE_PruefPlan_FAILURE:
        this.setActivatePruefPlanResult(action.result);
        break;
      case pruef_PlanConstants.DEACTIVATE_PruefPlan_SUCCESS:
        this.setDeActivatePruefPlanResult(action.result);
        break;
      case pruef_PlanConstants.DEACTIVATE_PruefPlan_FAILURE:
        this.setDeActivatePruefPlanResult(action.result);
        break;
      case pruef_PlanConstants.GET_CHECKLIST_SUCCESS:
        this.setCheckListResult(action.result);
        break;
      case pruef_PlanConstants.GET_CHECKLIST_FAILURE:
        this.setCheckListResult(action.result);
        break;
      case pruef_PlanConstants.GET_CHECKLIST_DETAILS_SUCCESS:
        this.setCheckListDetails(action.result);
        break;
      case pruef_PlanConstants.GET_CHECKLIST_DETAILS_FAILURE:
        this.setCheckListDetails(action.result);
        break;
      case pruef_PlanConstants.PUBLISH_CHECKLIST_SUCCESS:
        this.setPublishCheckListResult(action.result);
        break;
      case pruef_PlanConstants.PUBLISH_CHECKLIST_FAILURE:
        this.setPublishCheckListResult(action.result);
        break;
      case pruef_PlanConstants.GET_CHECKLIST_FOR_EQ_GRP_SUCCESS:
        this.setCheckListForEqGrpResult(action.result);
        break;
      case pruef_PlanConstants.GET_CHECKLIST_FOR_EQ_GRP_FAILURE:
        this.setCheckListForEqGrpResult(action.result);
        break;
      case pruef_PlanConstants.DEACTIVATE_CHECKLIST_SUCCESS:
        this.setDeActivateChecklistResult(action.result);
        break;
      case pruef_PlanConstants.DEACTIVATE_CHECKLIST_FAILURE:
        this.setDeActivateChecklistResult(action.result);
        break;
      case pruef_PlanConstants.DELETE_CHECKLIST_SUCCESS:
        this.setDeleteChecklistResult(action.result);
        break;
      case pruef_PlanConstants.DELETE_CHECKLIST_FAILURE:
        this.setDeleteChecklistResult(action.result);
        break;
      case pruef_PlanConstants.SAVE_CHECKLIST_AS_TEMPLATE_SUCCESS:
        this.setSaveChecklistAsTemplateResult(action.result);
        break;
      case pruef_PlanConstants.SAVE_CHECKLIST_AS_TEMPLATE_FAILURE:
        this.setSaveChecklistAsTemplateResult(action.result);
        break;
      case pruef_PlanConstants.GET_CHECKLIST_TEMPLATES_SUCCESS:
        this.setChecklistTemplateResult(action.result);
        break;
      case pruef_PlanConstants.GET_CHECKLIST_TEMPLATES_FAILURE:
        this.setChecklistTemplateResult(action.result);
        break;
      case pruef_PlanConstants.DELETE_CHECKLIST_TEMPLATE_SUCCESS:
        this.setDeleteChecklistTemplateResult(action.result);
        break;
      case pruef_PlanConstants.DELETE_CHECKLIST_TEMPLATE_FAILURE:
        this.setDeleteChecklistTemplateResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}
const pruefPlanStores = new PruefPlanStores();
dispatcher.register(pruefPlanStores.handleCallback.bind(pruefPlanStores));
export default pruefPlanStores;
